import storage from "redux-persist/lib/storage/session";
import { currentUiVersion } from "store/types";
var persistKey = "ui";
export var persistConfig = {
    version: currentUiVersion,
    storage: storage,
    key: persistKey,
    whitelist: ["unitSystem"],
};
